import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { nymblAc, nymblRoleAccess } from "./nymbl-roles";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  plugins: [adminClient({ ac: nymblAc, roles: nymblRoleAccess })],
});

export const { signIn, signUp, signOut, useSession } = authClient;
